/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');

module.exports = dd.createClass({
	render: function(){
		var open = !!this.props.open;
		var max_height = _.has(this.props, 'max_height') && this.props.max_height > 0 ? this.props.max_height : 100;
		var speed = _.has(this.props, 'speed') ? this.props.speed : '.15s';

		return dd.div({style: {
				maxHeight: open ? max_height : 0,
				overflow: 'hidden',
				transition: 'max-height ' + speed + ' ease-in-out'
			}},
			this.props.children
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/widgets/SlideOpenDown.js